import { SampleEvents } from './SampleEvents';
import User from 'src/models/User';


export const requireNotNull = function (thing, message) {
  if (thing === null || thing === undefined) {
    if (!!message) {
      throw new Error(message);
    } else {
      throw new Error('Required variable is null');
    }
  }
};

export const isCollectionType = (collection) => {
  if (!collection) return false
  if (!collection.title || !collection.collection_type) return false
  return true
}

export const isQuestionType = (question) => {
  if (!question) return false
  if (!question.title || !question.question_type || !question.responses) return false
  return true
}

export const isCommentType = (comment) => {
  if (!comment) return false
  if (!comment.comment) return false
  return true
}

// {
//   "title": "string",
//   "vote_type": "string",
//   "vote_numeric_value": 0,
//   "description": "string"
// }
export const isVoteType = (vote) => {
  if (!vote) return false
  if (!vote.title || !vote.vote_type || vote.vote_numeric_value < 0 || !vote.collection_id || !vote.question_id || !vote.response_id) return false
  if (typeof vote.vote_numeric_value !== 'number') return false
  return true
}

const SAMPLES = {
  0: {
    questionType: 'multiple',
    sampleEventText: `Which one of these ideas is the most feasible that we should tackle first?`,
    sampleIdeaTexts: ['Portfolio Mgmt and Optimization', 'Infrastructure Optimization', 'Consultant Review and Effectiveness']

  },
  1: {
    questionType: 'default',
    sampleEventText: 'What questions or topics would you like to discuss today?',
    sampleIdeaTexts: [
      'How are our clients responding to the most recent changes in the product? How has onboarding been going?',
      'How are we tracking against the company roadmap for the year? Sometimes I get so focused on my daily work that I lose sight of the bigger picture. Can we track progress on this more regularly or publicly?',
      'What is our plan to improve our product development approach to deliver a higher % of features scheduled for releases?',
      'What was your biggest takeaway from our offsite last week?',
      `Are there any updates on the issues we've been having with system generated client communication emails?`
    ]
  },
  2: {
    questionType: 'scale',
    sampleEventText: `Please rate how well the topics were covered in today's meeting`,
    sampleIdeaTexts: ['1', '2', '3', '4', '5']

  },
}

export const addSamples = (events, user, stash = false) => {
  const userCreatedDate = User.getCreatedDate(user);

  const sampleDates = [userCreatedDate, userCreatedDate.subtract(2, 'days'), userCreatedDate.subtract(1, 'days')]
  const samples = []

  sampleDates.forEach((date, idx) => {
    const smapleNum = idx + 1

    if (stash && !stash[`HIDE_SAMPLE_EVENT_${smapleNum}`]) {
      samples.push(SampleEvents.create(
        user,
        smapleNum,
        date,
        SAMPLES[idx].questionType,
        SAMPLES[idx].sampleEventText,
        SAMPLES[idx].sampleIdeaTexts
      ));
    }
  })

  return [...events, ...samples]
}

export const QUESTION_TYPE_LABELS = {
  'default': 'Open-Ended',
  'binary': 'Yes/No',
  'scale': 'Rating Scale (1-5)',
  'multiple': 'Multiple Choice',
  'multiple_rating': 'Multiple Rating',
  'stack_rank': 'Stack Ranking'
};

export const QUESTION_TYPES = {
  'default': {
    id: 'default',
    text: QUESTION_TYPE_LABELS['default'],
    value: 'default'
  },
  'binary': {
    id: 'binary',
    text: QUESTION_TYPE_LABELS['binary'],
    value: 'binary',
    options: [{ name: 'Yes' }, { name: 'No' }],
    options_editable: false,
  },
  'multiple': {
    id: 'multiple',
    text: QUESTION_TYPE_LABELS['multiple'],
    value: 'multiple',
    options: [{ name: 'Option 1' }, { name: 'Option 2' }],
    options_editable: true,
  },
  'scale': {
    id: 'scale',
    text: QUESTION_TYPE_LABELS['scale'],
    value: 'scale',
    options: [{ name: '5' }, { name: '4' }, { name: '3' }, { name: '2' }, { name: '1' }],
    options_editable: false,
  },
  'multiple_rating': {
    id: 'multiple_rating',
    text: QUESTION_TYPE_LABELS['multiple_rating'],
    value: 'multiple_rating',
    options: [{ name: 'Option 1' }, { name: 'Option 2' }],
    options_editable: true,
  },
  'stack_rank': {
    id: 'stack_rank',
    text: QUESTION_TYPE_LABELS['stack_rank'],
    value: 'stack_rank',
    options: [{ name: 'Option 1' }, { name: 'Option 2' }],
    options_editable: true,
  },
};

export const QUESTION_LIBRARY = [
  {
    category: "Recognition",
    questions: [
      {
        question:
          "What ONE thing are you most proud of the team accomplishing during the past ( ) weeks?",
        type: "default",
      },
      {
        question:
          "Describe a standout performance by an individual or a team that deserves further applause",
        type: "default",
      },
    ],
  },
  {
    category: "Meetings",
    questions: [
      {
        question:
          "How effective were the topics covered in the meeting, and where do you need clarity?",
        type: "scale",
      },
      {
        question:
          "What question or topics would you like us to cover at next week’s meeting/town hall/offsite?",
        type: "default",
      },
    ],
  },
  {
    category: "Project Management",
    questions: [
      {
        question:
          "I understand what we’re trying to achieve with this project.",
        type: "binary",
      },
      {
        question:
          "I know how this project impacts my team and how to communicate the impacts.",
        type: "binary",
      },
      {
        question:
          "I am confident this is the right direction for our organization/right solution for our business problem.",
        type: "binary",
      },
      {
        question:
          "Please rate your current level of confidence in the state of our project and suggest one thing we could do to get it back on track.",
        type: "scale",
      },
    ],
  },
  {
    category: "Alignment/Buy-In",
    questions: [
      {
        question: "I understand (Company) strategic plan.",
        type: "binary",
      },
      {
        question: "I am confident this is the right strategy for (Company).",
        type: "binary",
      },
      {
        question: "I understand how my role supports the (Company) strategy.",
        type: "binary",
      },
    ],
  },
  {
    category: "Performance Management",
    questions: [
      {
        question:
          "Of the following, which is most important to your personal development?",
        type: "multiple",
      },
      {
        question:
          "What is one thing leadership can do to support your development.",
        type: "default",
      },
      {
        question:
          "How frequently do you want focused performance and development discussions with your manager?",
        type: "multiple",
      },
    ],
  },
  {
    category: "Improvement",
    questions: [
      {
        question:
          "What is one thing we must do as a team to ensure success with this project?",
        type: "default",
      },
      {
        question:
          "(x) came back as an issue in our department. Please suggest one thing that would improve our understanding of how to overcome this issue.",
        type: "default",
      },
      {
        question:
          "Please rate the likelihood of success for our new rollout and suggest one thing we could do to strengthen its adoption.",
        type: "scale",
      },
      {
        question:
          "What is one thing we can do to improve productivity as a team?",
        type: "default",
      },
    ],
  },
];

export const questionTypeList = () => {
  const arr = [];
  for (const [, value] of Object.entries(QUESTION_TYPES)) {
    arr.push(value);
  }
  return arr;
};

export const defaultQuestionType = (product) => {
  if (product === 'survey') {
    return QUESTION_TYPES.multiple;
  }
  return QUESTION_TYPES.default;
}

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

export const convertToCSV = (objArray) => {
  const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
  let str = "";
  // process titles
  let title = "";
  for (const prop in objArray[0]) {
    if (title !== "") title += ",";
    title += prop;
  }
  str += title + "\r\n";
  // process rows
  for (let i = 0; i < array.length; i++) {
    let line = "";
    for (let index in array[i]) {
      if (line !== "") line += ",";
      let val = array[i][index];
      val = val.toString().replaceAll("\"", "\"\"");
      line += `"${val}"`;
    }
    str += line + "\r\n";
  }
  return str;
};
